import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Feedsmith',
    description: 'Turn any blog post into an Instagram carousel people save. Write it from a link, polish it in a built-in designer and plan it in a feed simulator before you post.',
    url: getOrigin()
}
